import { OnStreamEventSchema } from 'features/cantileverAISystem/components/aiControllerV3'
import {
  enforceDescriptions,
  EventData,
} from 'features/cantileverAISystem/components/enforceDescriptions'
import { AIResponseEvent } from 'features/cantileverAISystem/components/makeAiResponseEventDef'
import { AIPromptEventName } from 'features/cantileverAISystem/eventName'
import { z, ZodType } from 'zod'

export type AIPromptEvent = z.infer<typeof AIPromptEventSchema> & {
  availableResponseEvents: ZodType<Omit<AIResponseEvent, 'sessionId'>>[]
  eventSchema: z.ZodType
  onStream?: (event: z.infer<typeof OnStreamEventSchema>) => void
  onError?: (error: string) => void
}

export const AIPromptEventSchema = z.object({
  eventName: z.enum(AIPromptEventName),
  sessionId: z.string().optional(),
})

export const deprecated_makeAIPromptEventDef = <
  TEventName extends AIPromptEventName,
  TEventDataSchema extends EventData,
>({
  eventName,
  eventDataSchemaWithDescriptions,
}: {
  eventName: TEventName
  eventDataSchemaWithDescriptions: TEventDataSchema
}) => {
  enforceDescriptions(eventName, eventDataSchemaWithDescriptions)

  const eventSchema = AIPromptEventSchema.extend({
    eventName: z.literal(eventName),
    data: eventDataSchemaWithDescriptions,
  }).omit({ sessionId: true })

  return {
    eventName,
    eventSchema,
    createEvent: <
      AvailableResponseEventSchema extends ZodType<
        Omit<AIResponseEvent, 'sessionId'>
      >,
    >({
      data,
      availableResponseEvents,
      sessionId,
      onError,
      onStream,
    }: {
      data: z.infer<TEventDataSchema>
      availableResponseEvents: AvailableResponseEventSchema[]
      sessionId?: string
      onError?: AIPromptEvent['onError']
      onStream?: AIPromptEvent['onStream']
    }) => {
      return {
        eventName,
        data,
        eventSchema,
        sessionId,
        availableResponseEvents,
        onError,
        onStream,
      } as const satisfies AIPromptEvent & { data: z.infer<TEventDataSchema> }
    },
  }
}
